import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Flag } from '@bibliocommons/base-icons';
import { TextButton } from '@bibliocommons/base-buttons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { FormattedMessage } from 'react-intl';

export default class GroupSearchFeedbackButton extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleClick');
  }

  handleClick() {
    this.props.handleClick(this.props.bib);
  }

  render() {
    return (
      <TextButton className="cp-group-search-feedback-button" handleClick={this.handleClick}>
        <ScreenReaderMessage>
          <FormattedMessage id="group_search_feedback" />
        </ScreenReaderMessage>
        <Flag />
      </TextButton>
    );
  }
}

GroupSearchFeedbackButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  bib: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/GroupSearchFeedbackButton/GroupSearchFeedbackButton.jsx